/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/log-in-3";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "LogIn3";
export { I as LogIn3 };
